module.exports = __webpack_public_path__ + "static/media/ec2.e1266524.svg";